export default "__VITE_ASSET__cc76whUo__"